export default __webpack_public_path__ + "static/katie and mark jetten-d516f51e7ff3feb6a86491d2cb8a0569.webp";